/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RemainingCoverage/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function RemainingCoverage({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content/RemainingCoverage"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
let assignDetailsTxCategoryCoveragesOrthoCoveragesMaxLifetimeCoverageValueData = fromData.useDataValue({ viewPath,
context: 'assign_details',
path: 'tx_category_coverages.ortho_coverages.max_lifetime_coverage',
})
let txCategoryInsuredOrthoInsuredUsedLifetimeCoverageValueData = fromData.useDataValue({ viewPath,
context: 'tx_category_insured',
path: 'ortho_insured.used_lifetime_coverage',
})
let aggregateData = fromHelpers.getValue(assignDetailsTxCategoryCoveragesOrthoCoveragesMaxLifetimeCoverageValueData, txCategoryInsuredOrthoInsuredUsedLifetimeCoverageValueData)
  return (<React.Fragment
>
<div
  data-testid="RemainingCoverage.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-2bBEeO': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginRight={dtSpaceS}
 text="Remaining Coverage:"
 color={dtColorsNeutral800}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 data="assign_details.tx_category_coverages.ortho_coverages.max_lifetime_coverage"
 data="tx_category_insured.ortho_insured.used_lifetime_coverage"
 aggregate="helpers.js getValue"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}